import { Component } from '@angular/core'
import { NavParams, Events } from 'ionic-angular'
import { Location } from '../../services/location'

// Declare GeoJSON to Typescript
declare function GeoJSON(geojson: any, options: any): void

@Component({
  selector: 'map',
  template: '<div class="detail-map"></div>',
  providers: [Location]
})
export class Map {
  private config: any
  private map: any
  private journey: any
  private start: any
  private end: any

  constructor(params: NavParams, private events: Events, location: Location) {
    this.config = {
      style: new google.maps.StyledMapType([{
        'featureType': 'poi',
        'elementType': 'labels.text',
        'stylers': [{
          'visibility': 'off'
        }]
      }, {
          'featureType': 'road.highway',
          'elementType': 'geometry',
          'stylers': [{
            'visibility': 'simplified'
          }, {
              'hue': '#ffd500'
            }, {
              'lightness': 20
            }]
        }, {
          'featureType': 'road.arterial',
          'elementType': 'labels.icon',
          'stylers': [{
            'visibility': 'simplified'
          }, {
              'lightness': 20
            }]
        }, {
          'featureType': 'road.highway',
          'elementType': 'labels.icon',
          'stylers': [{
            'visibility': 'simplified'
          }, {
              'lightness': 20
            }]
        }, {
          'featureType': 'landscape.natural',
          'stylers': [{
            'visibility': 'on'
          }, {
              'lightness': 30
            }]
        }], {
          name: 'Plan'
        }),
      options: {
        zoom: 15,
        center: new google.maps.LatLng(location.lat, location.lng),
        disableDefaultUI: true,
        minZoom: 12
      }
    }

    events.subscribe('carpostal:detail:zoom', data => {
      let section = data.shift()

      if (section.geojson) {
        let bounds = new google.maps.LatLngBounds()

        for (let coordinate of section.geojson.coordinates) {
          bounds.extend(new google.maps.LatLng(coordinate[1], coordinate[0]))
        }

        this.map.fitBounds(bounds)
      } else {
        console.warn('Les correspondances ne possèdent pas de GeoJSON...')
      }
    })

    events.subscribe('carpostal:detail:draw', data => {
      setTimeout(() => {
        this.journey = data.shift()
        this.start = data.shift()
        this.end = data.shift()

        // Parse the result
        (<any>window).polylineMarkers = [];
        (<any>window).clones = [];
        (<any>window).polylines = [];

        for (let key = 0; key < this.journey.sections.length; key++) {
          let section = this.journey.sections[key];

          // Test Draw
          let style: any = {};
          let backStyle: any = {
            color: '#fff',
            opacity: 1
          };

          if (section.type === 'public_transport') {
            style.color = '#' + section['display_informations'].color;
            style.weight = 6;
            style.opacity = 1;

            backStyle.weight = 10;

            // Add marker on polylines
            for (let stop of section.stop_date_times) {
              let icon = {
                path: 'M9,12a3,3 0 1,0 6,0a3,3 0 1,0 -6,0',
                strokeColor: style.color,
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor: 'white',
                fillOpacity: 1,
                scale: 1,
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(12, 12)
              };

              let position = new google.maps.LatLng(stop['stop_point'].coord.lat, stop['stop_point'].coord.lon);
              let marker = new google.maps.Marker({
                position: position,
                icon: icon,
                cursor: 'pointer',
                map: this.map,
                zIndex: 1
              });
              (<any>marker).name = stop['stop_point'].name,

                (<any>window).polylineMarkers.push(marker);
            }
          } else if (section.type === 'street_network' ||
            section.type === 'transfer') {
            style.color = '#4d4f50';
            style.weight = 4;
            style.opacity = 1;
            style.path = 'M 0,-0.6 0,0.6';
            style.scale = 4;

            backStyle.weight = 6;
            backStyle.opacity = 0.7;

            // on contruit l'objet coordonées
            if (key === 0) {
              if (section.geojson) {
                section.geojson.coordinates.unshift([this.start.lng(), this.start.lat()]);
              } else {
                section.geojson = {
                  type: 'LineString',
                  coordinates: [
                    [this.start.lng(), this.start.lat()]
                  ]
                };
              }
            } else {
              let previous = this.journey.sections[key - 1].to[this.journey.sections[key - 1].to['embedded_type']].coord;

              if (section.geojson) {
                section.geojson.coordinates.unshift([
                  previous.lon,
                  previous.lat
                ]);
              } else {
                section.geojson = {
                  type: 'LineString',
                  coordinates: [
                    [previous.lon, previous.lat]
                  ]
                };
              }
            }

            if (key !== this.journey.sections.length - 1) {
              let after = this.journey.sections[key + 1].from[this.journey.sections[key + 1].from['embedded_type']].coord;
              section.geojson.coordinates.push([after.lon, after.lat]);
            } else {
              section.geojson.coordinates.push([this.end.lng(), this.end.lat()]);
            }
          }

          // Add polylines
          if (section.geojson) {
            let clone = new GeoJSON(section.geojson, {
              zIndex: 0,
              strokeWeight: backStyle.weight,
              strokeColor: backStyle.color,
              strokeOpacity: backStyle.opacity
            });

            let polyline = new GeoJSON(section.geojson, {
              zIndex: 1,
              strokeWeight: style.weight,
              strokeColor: style.color,
              strokeOpacity: section.mode === 'walking' ? 0 : style.opacity,
              icons: section.mode === 'walking' ? [{
                icon: {
                  path: style.path,
                  strokeOpacity: 0.9,
                  scale: style.scale
                },
                offset: '0',
                repeat: '14px'
              }] : ''
            });

            // Add polylines
            clone.setMap(this.map);
            polyline.setMap(this.map);
            (<any>window).clones.push(clone);
            (<any>window).polylines.push(polyline);
          }
        }

        new google.maps.Marker({
          position: this.start,
          icon: {
            url: '/img/start.png',
            size: new google.maps.Size(66, 37),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(33, 37)
          },
          cursor: 'pointer',
          map: this.map,
          zIndex: 4
        });
        new google.maps.Marker({
          position: this.end,
          icon: {
            url: '/img/end.png',
            size: new google.maps.Size(66, 37),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(33, 37)
          },
          cursor: 'pointer',
          map: this.map,
          zIndex: 4
        });

        let bounds = new google.maps.LatLngBounds();
        for (let polyline of (<any>window).polylines) {
          for (let path of polyline.getPath().getArray()) {
            bounds.extend(path);
          }
        }

        this.map.fitBounds(bounds);
      })
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.map = new google.maps.Map(document.querySelector('.detail-map'), this.config.options);
      //Associate the styled map with the MapTypeId and set it to display.
      this.map.mapTypes.set('Plan', this.config.style);
      this.map.setMapTypeId('Plan');
    })
  }

  onPageDidLeave() {
    // Reset style transform
    (<HTMLElement>document.querySelector('.detail-map')).style.transform = '';
  }

  ngOnDestroy() {
    this.events.unsubscribe('carpostal:detail:zoom', null);
    this.events.unsubscribe('carpostal:detail:draw', null);
  }
}
